import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ModuleUsageFactPreview from './ModuleUsageFactPreview';

const ModuleUsageFacts = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio', icon: 'icon-house' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title='Uso de módulos'
						links={breadcrumbLinks}
						icon={'icon-layout-grid'}
					/>
					<ModuleUsageFactPreview />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ModuleUsageFacts;
